import {List, Record} from 'immutable';
import User from 'records/User';
import moment from 'moment';

export class SummaryUserStats extends Record({
  user: null,
  talkListenRatioAvg: null,
  listenPercentage: null,
  interchangesPerMinuteAvg: null,
  callScoreAvg: null,
  callScoreAvgTrend: List(),
  teamScoreAvg: null,
}) {
  constructor(object) {
    super({
      ...object,
      listenPercentage: (1 - object.talkListenRatioAvg) * 100,
      callScoreAvgTrend: List(
        object.callScoreAvgTrend.data.map(d => ({
          ...d,
          date: moment(d.date),
        }))
      ),
      user: new User(object),
    });
  }
}
